import { render, staticRenderFns } from "./caracteristicTagSimplified.vue?vue&type=template&id=53e8fd21&scoped=true&lang=pug&"
import script from "./caracteristicTagSimplified.vue?vue&type=script&lang=js&"
export * from "./caracteristicTagSimplified.vue?vue&type=script&lang=js&"
import style0 from "./caracteristicTagSimplified.vue?vue&type=style&index=0&id=53e8fd21&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53e8fd21",
  null
  
)

export default component.exports